import { clearAuthHeader } from '../services/api';
import toast from 'react-hot-toast';

// Comprehensive logout utility
export const clearAllUserData = () => {
  // Clear authentication data
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');

  // Clear 2FA session data
  sessionStorage.removeItem('twofa_email');
  sessionStorage.removeItem('twofa_password');
  sessionStorage.removeItem('twofa_questions');
  sessionStorage.removeItem('twofa_phone');

  // Clear any session storage
  sessionStorage.removeItem('redirectAfterLogin');
  sessionStorage.removeItem('bookingData');
  sessionStorage.removeItem('flightSearchData');
  sessionStorage.removeItem('selectedFlight');
  sessionStorage.removeItem('passengers');
  sessionStorage.removeItem('paymentData');

  // Clear any other app-specific data
  localStorage.removeItem('searchHistory');
  localStorage.removeItem('userPreferences');
  localStorage.removeItem('recentSearches');
  localStorage.removeItem('savedFlights');
  localStorage.removeItem('bookingHistory');

  // Clear any cached API data
  localStorage.removeItem('airportCache');
  localStorage.removeItem('countryCache');
  localStorage.removeItem('flightCache');

  // Clear API authorization header
  clearAuthHeader();
};

// Simple logout that can be called from anywhere (including API interceptors)
export const performSimpleLogout = () => {
  // Clear all user data
  clearAllUserData();

  // Show toast notification
  toast.error('Your session has expired. Please login again.');

  // Redirect to home page
  window.location.href = '/';
};

// Enhanced logout function that can be used throughout the app
export const performLogout = async (dispatch, navigate) => {
  try {
    // Import the logout action dynamically to avoid circular dependencies
    const { logoutUser } = await import('../store/slices/authSlice');

    // Dispatch logout action (this will also clear localStorage)
    await dispatch(logoutUser()).unwrap();

    // Clear any additional data
    clearAllUserData();

    // Navigate to home page
    if (navigate) {
      navigate('/', { replace: true });
    }

    // Show success toast
    // toast.success('You have been logged out successfully');

  } catch (error) {
    // Even if API call fails, clear everything locally
    clearAllUserData();

    if (navigate) {
      navigate('/', { replace: true });
    }

    // Show error toast
    toast.error('Logout completed (with errors)');
  }
};